var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishedIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#08AA15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4252 5.52032C11.6349 5.70003 11.6592 6.01568 11.4795 6.22534C10.4183 7.46119 9.34198 8.69705 8.15036 9.80923C7.82724 10.1108 7.37922 10.5999 6.89983 10.5999C6.55682 10.5999 6.25393 10.3802 6.00611 10.1648C5.4223 9.65708 4.93274 9.01743 4.49039 8.38693C4.33203 8.16071 4.38687 7.84869 4.6131 7.69033C4.8393 7.53199 5.15103 7.58698 5.3094 7.81316L5.31 7.81401C5.70609 8.37679 6.14025 8.95619 6.66229 9.41014C6.74959 9.48606 6.82157 9.53914 6.87679 9.57232C7.09115 9.43196 7.28145 9.25232 7.46804 9.07817C8.63268 7.99118 9.68191 6.78148 10.7201 5.57468C10.8998 5.36502 11.2156 5.34061 11.4252 5.52032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedIconRounded);
export default __webpack_public_path__ + "static/media/finishedIconRounded.b3ff28329d622ad05ebf96a6d0ef94a0.svg";
export { ForwardRef as ReactComponent };